(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-list-image-hover"] && !window.DesignMode) return;
  try {
    
  document.querySelectorAll('.brands-list ul li').forEach(li => {
    if (window.innerWidth > 992) {
      li.addEventListener('mousemove', e => {
        let img = li.querySelector('img');
        img.style.left = e.x + 'px';
        img.style.top =  e.y + 'px';
      });
    }
  })

  } catch(e) { console.error(e); }
})();
})();
